export default __webpack_public_path__ + "static/media/success.5d6ff880.png";